<template>
  <c-flex justifyContent="center" align="center">
    <c-button
      v-if="currentPage > 3"
      py="0"
      px="14px"
      mr="8px"
      h="32px"
      min-w="32px"
      variant="outline"
      borderRadius="30px"
      backgroundColor="transparent"
      font-size="14px"
      font-weight="normal"
      @click="onClickFirstPage"
    >
      First
    </c-button>

    <c-button
      p="0"
      mr="16px"
      w="32px"
      h="32px"
      min-w="32px"
      variant="outline"
      borderRadius="30px"
      backgroundColor="transparent"
      @click="onClickPreviousPage"
      :disabled="isInFirstPage"
    >
      <c-icon name="chevron-left" size="24px" />
    </c-button>

    <c-button
      p="0"
      m="0"
      w="32px"
      h="32px"
      min-w="32px"
      mx="4px"
      borderRadius="30px"
      font-weight="normal"
      :backgroundColor="
        isPageActive(page) ? 'rgba(0, 140, 129, 0.3)' : 'transparent'
      "
      color="brand.900"
      :class="{
        last: page == totalPages && Math.abs(page - currentPage) > 2,
      }"
      v-chakra="{
        ':hover': {
          bg: 'rgba(0, 140, 129, 0.3)',
          color: 'brand.900',
        },
      }"
      v-for="page in pages"
      :key="page"
      @click="onClickPage(page)"
    >
      {{ page }}
    </c-button>
    <c-button
      p="0"
      ml="16px"
      w="32px"
      h="32px"
      min-w="32px"
      variant="outline"
      borderRadius="30px"
      backgroundColor="transparent"
      @click="onClickNextPage"
      :disabled="isInLastPage"
    >
      <c-icon name="chevron-right" size="24px" />
    </c-button>
  </c-flex>
</template>
<script>
export default {
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 3,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    startPage() {
      // When on the first page
      if (this.currentPage === 1) {
        return 1
      }

      // When on the last page
      if (this.currentPage === this.totalPages) {
        return this.totalPages - this.maxVisibleButtons
      }

      // When inbetween
      return this.currentPage - 1
    },
    pages() {
      const range = []

      for (
        let i = this.startPage;
        i <=
        Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        i++
      ) {
        if (i < this.totalPages && i > 0) {
          range.push(i)
        }
      }
      range.push(this.totalPages)
      return range
    },
    isInFirstPage() {
      return this.currentPage === 1
    },
    isInLastPage() {
      return this.currentPage === this.totalPages
    },
  },
  methods: {
    onClickFirstPage() {
      this.$emit("pagechanged", 1)
    },
    onClickPreviousPage() {
      this.$emit("pagechanged", this.currentPage - 1)
    },
    onClickPage(page) {
      this.$emit("pagechanged", page)
    },
    onClickNextPage() {
      this.$emit("pagechanged", this.currentPage + 1)
    },
    onClickLastPage() {
      this.$emit("pagechanged", this.totalPages)
    },
    isPageActive(page) {
      return this.currentPage === page
    },
  },
}
</script>
<style>
.last {
  margin-left: 32px;
}
.last::before {
  content: "...";
  left: -25px;
  position: absolute;
}
</style>
